import { Box, Grid, Stack } from '@mui/material/';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import useMyMApi from "../../hooks/useMyMApi";
import useValidationRules from '../../hooks/useValidationRules';
import useWebContext from '../../hooks/useWebContext';
import { MyMButton, MyMCloseButton } from '../../ui-elements/MyMButton';
import { MyMLabel } from "../../ui-elements/MyMLabel";
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import CustomDataGrid from "../../ui-parts/CustomDataGrid";
import ValidatableAttachmentFiles from '../../ui-parts/ValidatableAttachmentFiles';
import ValidatableTextBox from '../../ui-parts/ValidatableTextBox';
import { ValidatableTreeCheckbox } from "../../ui-parts/ValidatableTreeCheckbox";
import ModalExcludeDestination from '../MyM207_ExcludeDestination/ExcludeDestination';

/**MyMine Version2.0 EmailDelivery画面新規追加
 * EmailDelivery Page Component
 */
const EmailDelivery = (props) => {

  const screenId = 'MyM206';
  const { controlSettings, messageList } = useWebContext(screenId);
  const { formState, control, handleSubmit, clearErrors, trigger } = useForm({
    mode: 'onSubmit',
  })
  const validationRules = useValidationRules();
  const [isLoading, setIsLoading] = useState(false);
  const apiRequest = useMyMApi(screenId);
  const [companyList, setCompanyList] = useState([]);
  const [companyChecked, setCompanyChecked] = useState([]);
  const [userList, setUserList] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [files, setFiles] = useState([]);

  const [sendUserList, setSendUserList] = useState([]);
  const [excludeUserList, setExcludeUserList] = useState([]);

  const [isSendTest, setIsSendTest] = useState(true);

  /**モーダル画面にてリスト更新 */
  const handleValueChange = (newValue1, newValue2) => {
    setSendUserList(newValue1);
    setExcludeUserList(newValue2);
  };

  const columns = [
    {
      field: "USER_ID",
      headerName: controlSettings.LabelList.lblUserIdTitle,
      flex: 1.2,
    },
    {
      field: "USER_NAME",
      headerName: controlSettings.LabelList.lblNameTitle,
      flex: 1,
    },
    {
      field: "COMPANY_NAME_DISP",
      headerName: controlSettings.LabelList.lblCompanyTitle,
      flex: 0.7,
    },
    {
      field: "ROLE_NAME",
      headerName: controlSettings.LabelList.lblRoleTitle,
      flex: 0.6,
    },
  ];

  useEffect(() => {
    const callbackPageLoadContext = async (result) => {
      setCompanyList([...result.CompanyList]);
      setUserList([...result.UserInfoList]);
      setSendUserList([]);
      setIsLoading(false);
    }

    const callbackFailed = () => setIsLoading(false);

    apiRequest.requestJson('api/user-bulk-mail/load', 'GET', callbackPageLoadContext, callbackFailed)
    setIsLoading(true);
  }, []);

  /** Testボタン押下時処理 */
  const onClickTest = () => {

    /** Test処理 */
    const testSend = (data, e) => {
      if (window.confirm(messageList.MyM_MSG_I_0120)) {
        const formData = new FormData();
        formData.append(`Title`, data.title);
        formData.append(`Content`, data.content);
        formData.append(`IsTestSend`, true);

        files.forEach((file, i) => { formData.append(`AttachmentFile`, file); })

        const callbackSuccess = () => {
          window.alert(messageList.MyM_MSG_I_0121);
          setIsLoading(false);
        }

        const callbackFailed = () => setIsLoading(false);
        apiRequest.requestForm('api/user-bulk-mail/send-test', 'POST', callbackSuccess, callbackFailed, formData);

        setIsLoading(true);
      }
    }

    setIsSendTest(true);
    handleSubmit(testSend, onError)();
  }

  /** Sendボタン押下時処理 */
  const onClickSend = () => {

    /** 送信予約処理 */
    const send = (data, e) => {
      if (sendUserList.length <= 0) {
        window.alert(messageList.MyM_MSG_E_0135);
      }
      else if (window.confirm(messageList.MyM_MSG_I_0112)) {
        const formData = new FormData();
        formData.append(`Title`, data.title);
        formData.append(`Content`, data.content);
        files.forEach((file, i) => { formData.append(`AttachmentFile`, file); })

        sendUserList.forEach((user, j) => { formData.append(`ToUserSequenceNoList`, user.id); })

        const callbackSuccess = () => {
          window.alert(messageList.MyM_MSG_I_0114);
          setIsLoading(false);

          window.close();
        }

        const callbackFailed = () => setIsLoading(false);

        //POST
        apiRequest.requestForm('api/user-bulk-mail/schedule-sending', 'POST', callbackSuccess, callbackFailed, formData);

        setIsLoading(true);
      }
    };

    setIsSendTest(false);
    handleSubmit(send, onError)();

  }

  const onError = (errors, e) => {
    window.alert(messageList.MyM_MSG_E_0003);
  };

  /** ModalCloseイベント */
  const handleDetailModalClose = (e, r) => {
    if (r === 'backdropClick') return;
    setIsDetailModalOpen(false);
  }

  if (companyList.length === 0)
    return <MyMProgress />

  /** ユーザリストの内容定義 */
  const dataList = userList.map((row) => {
    return {
      id: row.UserSequenceNo,
      USER_ID: row.UserId,
      USER_NAME: `${row.FirstName ?? ''} ${row.LastName ?? ''}`.trim(),
      COMPANY_NAME_DISP: row.CompanyNameDisp,
      ROLE_NAME: row.RoleName,
    }
  });

  return (
    <Box sx={{ paddingLeft: '30vh', paddingRight: '30vh', marginTop: 2 }}>
      {isLoading && <MyMProgress />}
      <Grid container>
        <Grid item xs={12}>
          <MyMLabel fontSize='1.2rem'>{controlSettings.LabelList.lblTitle}</MyMLabel>
          <ValidatableTextBox
            height='100%'
            control={control}
            name="title"
            formState={formState}
            maxLength={200}
            rules={
              {
                ...validationRules.required(),
                ...validationRules.maxLength(200),
              }
            }
          >
          </ValidatableTextBox>
        </Grid>
        <Grid item xs={12} className='mt-3'>
          <MyMLabel fontSize='1.2rem'>{controlSettings.LabelList.lblContent}</MyMLabel>
          <ValidatableTextBox
            multiline
            rows={8}
            maxLength={2000}
            height='100%'
            control={control}
            name="content"
            formState={formState}
            rules={
              {
                ...validationRules.required(),
                ...validationRules.maxLength(2000),
              }
            }
          >
          </ValidatableTextBox>
        </Grid>
        <Grid item xs={12} className='mt-3'>
          <MyMLabel fontSize='1.2rem'>{controlSettings.LabelList.lblFileName}</MyMLabel>
          <ValidatableAttachmentFiles
            controlSettings={controlSettings}
            messageList={messageList}
            control={control}
            files={files}
            setFiles={setFiles}
            clearErrors={clearErrors}
            formState={formState}
            trigger={trigger}
            fileSizeValidMessageKey='MyM_MSG_W_0099'
          />
        </Grid>
      </Grid>
      <Grid container sx={{ mt: "20px" }}>
        <Grid item xs={12}>
          <MyMLabel fontSize='1.2rem'>{controlSettings.LabelList.lblDestination}</MyMLabel>
        </Grid>
        <Grid item xs={4} >
          <MyMLabel fontSize='1.2rem'>{controlSettings.LabelList.lblCompany}</MyMLabel>
        </Grid>
        <Grid item xs={8} sx={{ paddingLeft: 3 }}>
          <Grid container>
            <Grid item xs={7}>
              <MyMLabel fontSize='1.2rem'>{controlSettings.LabelList.lblUsers}</MyMLabel>
            </Grid>
            <Grid item xs={3}>
              <MyMButton onClick={() => setIsDetailModalOpen(true)} sx={{ height: '30px', width: '100px', marginBottom: '8px' }}>{controlSettings.LabelList.btnDetail}</MyMButton>
            </Grid>
            <Grid item xs={2}>
              <MyMLabel fontSize='1.2rem' sx={{ paddingLeft: '30px', textAlign: 'right' }}>{sendUserList.length}</MyMLabel>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <ValidatableTreeCheckbox
            needsCascade={true}
            controllerName="trvCompany"
            treeItemList={companyList}
            checkedList={companyChecked}
            setChecked={(companyChecked) => {
              /**選択Companyでフィルタ */
              var filterDataList = dataList.filter((output) => {
                var selectedCompanyNameList = []
                for (let i = 0; i < companyList.length; i++) {
                  for (let j = 0; j < companyChecked.length; j++) {
                    if (companyList[i].Id.toString() === companyChecked[j].toString()) {
                      selectedCompanyNameList.push(companyList[i].Name)
                      break;
                    }
                  }
                }

                var excludeUserIds = excludeUserList.map((val) => {
                  return val.USER_ID;
                })

                if (selectedCompanyNameList.includes(output.COMPANY_NAME_DISP)) {
                  if (!excludeUserIds.includes(output.USER_ID))
                    return true;
                }
                return false;
              });

              setSendUserList(filterDataList)
              if (companyChecked.length === 0) {
                setExcludeUserList([])
              }
              setCompanyChecked(companyChecked)
            }}
            control={control}
            formState={formState}
            trigger={trigger}
            clearText={controlSettings.LabelList.btnCompanyClearAll}
            height="485px"
            rules={{ ...validationRules.listRequired(companyChecked, /* Test送信時は必須チェック不要 */() => isSendTest === false) }}
          />
        </Grid>
        <Grid item xs={8} sx={{ paddingLeft: 3 }}>
          <Box sx={{ height: '485px', backgroundColor: '#F5F5F5' }}>
            <CustomDataGrid
              uniquyKey={(row) => row.id}
              name='sendusers'
              columns={columns}
              dataList={sendUserList}
            >
            </CustomDataGrid>
          </Box>
        </Grid>

        <Grid item xs={12} className='d-flex justify-content-end'>
          <Stack direction='row' spacing={3} className='my-3' sx={{ 'button': { width: 150 } }}>
            <MyMButton onClick={onClickTest}>{controlSettings.LabelList.btnTest}</MyMButton>
            <MyMButton onClick={onClickSend}>{controlSettings.LabelList.btnSend}</MyMButton>
            <MyMCloseButton closeText={controlSettings.LabelList.btnClose} />
          </Stack>
        </Grid>
      </Grid>

      <MyMModal open={isDetailModalOpen} onClose={handleDetailModalClose} width='80%' height='75%'>
        <ModalExcludeDestination sendUserList={sendUserList} excludeUserList={excludeUserList} handleModalClose={handleDetailModalClose} handleValueChange={handleValueChange} formState={formState} control={control} />
      </MyMModal>
    </Box>
  );
}
export default EmailDelivery;